import { apiInstances } from '../../../../libs';

const { post } = apiInstances.routesInstance;

export default async function optimizeRoute({ id_route, ...rest }) {
  return post(`/routes/${id_route}/optimize`, rest);
}
